<template>
    <FileUpload
        :ref="name"
        :accept="accept"
        :auto="auto"
        :fileLimit="fileLimit"
        :maxFileSize="maxFileSize"
        :name="paramName"
        :showCancelButton="false"
        :showUploadButton="showUploadButton"
        :url="url"
        v-bind="$attrs"
        :previewWidth="150"
        :disabled="disabled"
        @error="onError"
        @upload="onUpload"
        @before-send="onBeforeSend">
        <template #empty>
            <span>{{ emptyMessage }}</span>
        </template>
    </FileUpload>
</template>

<script>
import FileUpload from "primevue/fileupload";

export default {
    name: 'CustomDnaCardUploader',
    components: {
        FileUpload
    },
    inheritAttrs: false,
    props: {
        name: {
            type: String,
            default: 'fileUploader'
        },
        paramName: {
            type: String,
            default: 'file'
        },
        url: {
            type: String,
            required: true
        },
        accept: {
            type: String,
            default: 'image/*,.pdf,.doc,.docx,.txt,.rtf,.odt'
        },
        maxFileSize: {
            type: Number,
            default: 20000000
        },
        showUploadButton: {
            type: Boolean,
            default: false
        },
        auto: {
            type: Boolean,
            default: true
        },
        fileLimit: {
            type: Number,
            default: 1
        },
        emptyMessage: {
            type: String,
            default: 'Drag and drop file here to upload.'
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    emits: ['upload', 'before-send'],
    methods: {
        onBeforeSend(event) {
            if (localStorage.getItem("token") !== null) {
                event.xhr.setRequestHeader('Authorization', "Bearer " + localStorage.getItem("token"));
            }

            this.$emit('before-send', event);
        },
        onUpload(event) {
            this.$emit('upload', event);
            this.$toast.add({
                severity: "success",
                summary: this.$t('message.other.success'),
                detail: this.$t('message.other.fileUploaded'),
                life: 3000,
            });
        },
        onError(error) {
            this.$refs[this.name].clear();
            const message = error.response?.data?.message || this.$t('unknownError');
            this.$toast.add({
                severity: "error",
                summary: this.$t('message.other.unknownError'),
                detail: message,
                life: 5000,
            });
        }
    }
}
</script>
